import React from 'react';
import __ from 'lodash';

class DdBab extends React.Component{
    render(){
        return (
            this.props.bab.map((val) =>
                <option key={val.id_materi_pokok} value={val.id_materi_pokok}>{val.nama_materi_pokok}</option>
            )            
        )
    }
}

export default DdBab;